// @flow
import * as React from "react"
import { withHandlers, type HOC } from "recompose"
import CrossIcon from "assets/icons/CrossIcon"
import { StyledOverlay, Body, Cross, ScrollTable, ScrollTableCell } from "./styled"

class ModalBody<P: *> extends React.Component<P> {
  componentDidMount() {
    window.addEventListener("keydown", this.props.escapeListener)
    const body = document.body
    if (body) {
      body.classList.add("overflowHidden")
    }
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.props.escapeListener)
    const body = document.body
    if (body) {
      body.classList.remove("overflowHidden")
    }
  }

  render() {
    const { children, close, wide } = this.props

    return (
      <StyledOverlay open dark onClick={close}>
        <ScrollTable>
          <ScrollTableCell>
            <Body onClick={e => e.stopPropagation()} wide={wide}>
              {close && (
                <Cross onClick={close}>
                  <CrossIcon />
                </Cross>
              )}
              {children}
            </Body>
          </ScrollTableCell>
        </ScrollTable>
      </StyledOverlay>
    )
  }
}

type Outter = {|
  close?: Function,
  children: React.Node,
  wide?: boolean,
|}

const enhancer: HOC<*, Outter> = withHandlers({
  escapeListener: props => e => {
    if (e.code === "Escape" && props.close) {
      props.close()
    }
  },
})

export default enhancer(ModalBody)



// WEBPACK FOOTER //
// ./src/modals/_Body/index.js